import React, { memo } from 'react';
export var Close = /*#__PURE__*/memo(function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '26px' : _ref$width,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#757575' : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '26px' : _ref$height;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 26 26",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, "close"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    id: "Re-Branded-Designs",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LogIn---Comp-1b-Copy",
    transform: "translate(-552.000000, -22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(548.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame_-_24px"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "34",
    height: "34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_Icons",
    transform: "translate(4.000000, 4.000000)",
    fill: color,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "25.6374444 2.46566667 23.5935556 0.423222222 13.0606667 10.9575556 2.52633333 0.423222222 0.482444444 2.46566667 11.0167778 13 0.482444444 23.5343333 2.52633333 25.5767778 13.0606667 15.0424444 23.5935556 25.5767778 25.6374444 23.5343333 15.1031111 13"
  })))))));
});